export const GET_ALL_EQUIPMENTS = 'GET_ALL_EQUIPMENTS';
export const CURRENT_PAGE = 'CURRENT_PAGE';
export const PRELOADER = 'PRELOADER';



